var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8839 8.11612C20.372 8.60427 20.372 9.39573 19.8839 9.88388L12.8839 16.8839C12.3957 17.372 11.6043 17.372 11.1161 16.8839L4.11612 9.88388C3.62796 9.39573 3.62796 8.60427 4.11612 8.11612C4.60427 7.62796 5.39573 7.62796 5.88388 8.11612L12 14.2322L18.1161 8.11612C18.6043 7.62796 19.3957 7.62796 19.8839 8.11612Z",
    fill: "#818181"
  })));
};
export default SvgDownArrow;